export class ButtonControl {
  public isPressed = false;

  public wasPressedThisFrame = false;

  public wasReleasedThisFrame = false;
}
